import BaseApi from './base.api'
import ApiService from '@services/api.service'

export default {
    ...BaseApi,
    ... {
        resource: 'prev-school-types'
    },
    getTypes(params = null) {
        return ApiService.get(`/${this.resource}/get-types`, params)
    },
    toggleStatus(payload) {
        // expects { id, school_id, is_active }
        return ApiService.post(`/${this.resource}/${payload.id}/toggle-status`, payload);
    }
}